export default __webpack_public_path__ + "99c033a035caf7f76cb9be4c2cf3b0f2.svg";